import React, { useCallback, useContext, useState } from "react";
import FilterSecondPage from "./FilterSecondPage";
import TopkpisSecond from "./TopkpisSecond";
import TopkpisSecondMain from "./TopkpisSecondMain";
import RealWorldBox from "./SecondPageCharts/RealWorldBox";
import NetEnergydBox from "./SecondPageCharts/NetEnergydBox";
import RealWorldBar from "./SecondPageCharts/RealWorldBar";
import NetEnergyBar from "./SecondPageCharts/NetEnergyBar";
import ModeUtilization from "./SecondPageCharts/ModeUtilization";
import AvgDDBar from "./SecondPageCharts/AvgDDBar";
import Torquespeed from "./SecondPageCharts/Torquespeed";
import TorqueBox from "./SecondPageCharts/TorqueBox";
import Modal from "./SecondPageCharts/Modal";
import moment from "moment";
import { INIT_FILTER_STATE } from "../../../constants/driveglobalfilterinitalstates";

import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function PageSecond(props) {
  const [secondPageState, setSecondPageState] = useState({
    startDate: props.gloablfilter.startDate,
    endDate: props.gloablfilter.endDate,
    vin_num: props.gloablfilter.VIN_NUM.toString(),
    soc_per: props.gloablfilter.SOC,
  });

  const filterSubmited = useCallback((data) => {
    setSecondPageState(data);
  }, []);

  const pageChange = useCallback((data) => {
    props.pageChange();
  }, []);

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <FilterSecondPage
        onsubmit={filterSubmited}
        pageChange={pageChange}
        secondPageState={secondPageState}
      />
      <div className="container-fluid">
        <TopkpisSecond
          gloablfilter={secondPageState}
          apiend="drivesecondpage/topkpis"
        />
        <TopkpisSecondMain
          gloablfilter={secondPageState}
          apiend="drivesecondpage/topkpismain"
        />
        <section className="graphs">
          <div className="row">
            <div className="col-md-12 col-sm-6 col-lg-6">
              <div className="chartbox">
                <div className="row">
                  <RealWorldBox
                    gloablfilter={secondPageState}
                    apiend="drivesecondpagecharts/realworldbox"
                  />
                  <div className="col-md-6">
                    <RealWorldBar
                      apiend="drivesecondpagecharts/realworldbar"
                      gloablfilter={secondPageState}
                    ></RealWorldBar>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-sm-6 col-lg-6 pl-0 evtpks-pl0">
              <div className="chartbox">
                <div className="row">
                  <NetEnergydBox
                    gloablfilter={secondPageState}
                    apiend="drivesecondpagecharts/netenergybox"
                  ></NetEnergydBox>
                  <div className="col-md-6">
                    <NetEnergyBar
                      apiend="drivesecondpagecharts/netenergybar"
                      gloablfilter={secondPageState}
                    ></NetEnergyBar>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Row Ends here */}
          <div className="row mt-4 mb-3 equal-cols">
            {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-md-3 col-sm-12 pr-0 ">
                <Torquespeed
                  apiend="drivesecondpagecharts/torquespeed"
                  gloablfilter={secondPageState}
                ></Torquespeed>
              </div>
            )}
            {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-md-3 col-sm-12 pr-0">
                <TorqueBox
                  apiend="drivesecondpagecharts/torquebox"
                  gloablfilter={secondPageState}
                ></TorqueBox>
              </div>
            )}
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-md-3 col-sm-12 pr-0"
                  : "col-md-12 col-sm-6 col-lg-6"
              }
            >
              <div className="v-title chartbox">
                <div className="titlebg">Soc Discharge/Cycle Analysis</div>
                <AvgDDBar
                  apiend="drivesecondpagecharts/avgddBar"
                  gloablfilter={secondPageState}
                ></AvgDDBar>
              </div>
            </div>
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-md-3 col-sm-12 pr-0"
                  : "col-md-12 col-sm-6 col-lg-6 pl-0 evtpks-pl0"
              }
            >
              <div className="v-title chartbox">
                <div className="titlebg">Mode utilization</div>
                <ModeUtilization
                  gloablfilter={secondPageState}
                  apiend="drivesecondpagecharts/modeutilization"
                ></ModeUtilization>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default PageSecond;
